import { getStressAssessmentRole } from '@fukuri-admins/utils/common/cookies';
import { Navigate, Outlet } from 'react-router-dom';
import { IS_STRESS_CHECK_IMPLEMENTER_BUILD } from '~/constants';
import { ROUTES } from '~/utils/routes';

type Props = {
  /**
   * 役割 Cookie の判定をスキップするか
   *
   * true のとき role-select 画面を経由せず、実務担当者としてストレスチェック画面を直接表示する
   */
  skipRoleCheck: boolean;
};

export const StressAssessmentRoleRoute: React.FC<Props> = ({ skipRoleCheck }) => {
  // 実施者ビルドでは role-select 画面を経由しない運用のため役割Cookieが存在せず、
  // 判定するとストレスチェック配下すべてが role-select へリダイレクトされてしまう。
  // そのため判定をスキップしてそのまま Outlet を描画する。
  if (IS_STRESS_CHECK_IMPLEMENTER_BUILD || skipRoleCheck) {
    return <Outlet />;
  }

  const stressAssessmentRole = getStressAssessmentRole();
  if (!stressAssessmentRole) {
    return <Navigate to={ROUTES.STRESS_ASSESSMENTS.ROLE_SELECT} />;
  }

  return <Outlet />;
};
